module.exports = __webpack_public_path__ + "src/assets/img/invmodel.39c29b91.jpg";